module.exports = __webpack_public_path__ + "img/rightIcon.c1f21e91.svg";